import React from 'react';
import Logo from "./Logo";
import '../../css/login.css';

class HelpContainer extends React.Component {
    render() {
        return (
            <div className="help-container">
                <Logo/>
                <div className="help-message">
                    <h1 className="help-title">Workday Developer Site Account Help Center</h1>
                    <h2>Sign In to an Application</h2>
                    <div className="help-section">
                        <p>Sign in to the tenant using your tenant alias. Example: tenant_alias. The tenant alias is
                            provided by your Workday administrator.</p>
                        <p>
                            Workday Extend uses the tenant alias to send you to the correct customer tenant to sign in.
                            If you don’t know your tenant alias, please contact your Workday administrator.
                            If you need to sign in to the tenant directly without being redirected to the single sign-on
                            provider, click <strong>Bypass Single Sign-On Redirect</strong> and enter your tenant alias.
                        </p>
                    </div>

                    <h2>Sign in as a Developer to the Workday Developer Site</h2>
                    <div className="help-section">

                        <h4>New Users</h4>
                        <p>As a new user, we will send you a verification email to set up your account.</p>
                        <p>To set up your account:</p>
                        <ol>
                            <li>Click the verification link in the welcome email.</li>
                            <li>Enter and confirm your password, and then click <strong>Set Password</strong>.</li>
                            <li>
                                Use an authenticator app to scan the QR code or enter the TOTP secret key, and then click <strong>Continue</strong>.
                                <ul>
                                    <li>Workday Developer Site requires multi-factor authentication using an authenticator app on your mobile device that will generate codes even
                                        if you
                                        don’t have access to an internet connection or mobile service.
                                    </li>
                                </ul>
                            </li>
                            <li>Enter a code from the authenticator app, and then click <strong>Authenticate</strong>.</li>
                        </ol>

                        <h4>Existing Users</h4>
                        <p>If you are an existing user:</p>
                        <ol>
                          <li>Enter your email address in the <strong>Email</strong> field, and then click <strong>Continue</strong>.</li>
                          <li>Enter your password in the <strong>Password</strong> field, and then click <strong>Continue</strong>.</li>
                          <li>Enter a code from the authenticator app, and then click <strong>Authenticate</strong>.</li>
                        </ol>

                        <h4>Reset Password</h4>
                        <p>To reset your password:</p>
                        <ol>
                            <li>Enter your email address in the <strong>Email</strong> field, and then click <strong>Continue</strong>.</li>
                            <li>Click the <strong>Forgot Password?</strong> link.
                                <ul>
                                    <li>You will receive an email with a link to reset your password.</li>
                                </ul>
                            </li>
                            <li>Click the link in the reset password email.</li>
                            <li>Enter and confirm your new password, and then click <strong>Set Password</strong>.</li>
                        </ol>

                        <h4>Retrieve an Authentication Code</h4>
                        <p>To retrieve your authentication code, navigate to your authenticator app and enter the six-digit code.</p>
                        <p>
                            If you have a new phone or no longer have the authenticator app and are a Workday Extend customer, please contact your Designated Support Contact who can contact Workday Support to reset your authentication code.  If you are a Workday Journeys customer, please contact Workday Support to reset your authentication code.
                        </p>
                  </div>
                </div>
            </div>
        );
    }
}

export default HelpContainer;
